import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  IconButton,
  TextField,
  Button
} from '@mui/material';

import DialogWrapper from '@/components/DialogWrapper';
import { Close as CloseIcon } from '@mui/icons-material';

import { UserMetrics } from '@/api/dashboard';


interface UserDialogProps {
    user: UserMetrics | null;
    onClose: () => void;
    detailsDialogOpen: boolean;
}

const DashboardUserDialog: React.FC<UserDialogProps> = ({ user, onClose,detailsDialogOpen }) => {
   
    if (!user) return null;
    
    return (
        <DialogWrapper open={detailsDialogOpen} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
                <DialogContent>
                  <Box sx={{ mt: 2 }}>
                    {/* Compact summary row: read-only Email and Last Login */}
                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, mb: 0 }}>
                      <TextField
                        label="Display Name"
                        value={user.display_name || ''}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        slotProps={{ 
                          input:{
                            readOnly: true }}
                        }
                      />
                      <TextField
                        label="Business Unit"
                        value={user.business_unit || 'Unassigned'}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        slotProps={{ 
                          input:{
                            readOnly: true }}
                        }
                      />
                    </Box>
                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, mb: 0 }}>
                      <TextField
                        label="Total Messages"
                        value={user.total_messages || '0'}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        slotProps={{ 
                          input:{
                            readOnly: true }}
                        }
                      />
        
                      <TextField
                        label="Total Cost"
                        value={user.total_cost || '0'}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        slotProps={{ 
                          input:{
                            readOnly: true }}
                        }
                      />
                    </Box>
                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr' }, gap: 2, mb: 0 }}>
                      <TextField
                        label="Most Used Model"
                        value={user.most_used_model || 'Unknown'}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        slotProps={{ 
                          input:{
                            readOnly: true }}
                        }
                      />
                    </Box>                
                  </Box>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'flex-end' }}>
                  <Box sx={{ pr: 2, pb:  2 }}>
                    <Button onClick={onClose} color="primary" variant="contained" sx={{ mr: 1 }}>Close</Button>
                </Box>
            </DialogActions>
        </DialogWrapper>
    )
}

export default DashboardUserDialog;